$(function() {
    let $root = $('html, body');

    /* section-background-video-slider */
    new Swiper(".section-background-video-slider", {
        navigation: {
            nextEl: ".section-background-video-slider .swiper-button-next",
            prevEl: ".section-background-video-slider .swiper-button-prev",
        },
    });

    /* shop-the-look-technology-slider */
    let stlts = new Swiper(".shop-the-look-technology-swiper", {
        navigation: {
            nextEl: ".shop-the-look-technology-swiper .swiper-button-next",
            prevEl: ".shop-the-look-technology-swiper .swiper-button-prev",
        },
    });

    $(".shop-the-look--mobile .thb-hotspot").click(function(e) {
        stlts.slideTo($(this).data("quick-view-count") - 1);
    });

    /* custom-slider-auto */
    new Swiper(".custom-slider-auto", {
        slidesPerView: "auto",
        spaceBetween: 15,
        scrollbar: {
            el: $(".custom-slider-auto .swiper-scrollbar")[0],
            draggable: true
        },
        navigation: {
            nextEl: $(".custom-slider-auto .swiper-button-next")[0],
            prevEl: $(".custom-slider-auto .swiper-button-prev")[0],
        },
        breakpoints: {
            768: {
                spaceBetween: 30,
            }
        }
    });

    /* ego-c-section-bg - This is how we can add background behind multiple sections */
    window.getEgoCSectionBackgroundHeight = function() {
        $(".ego-c-section-bg").each(function (i, obj) {
            let _obj = $(obj);
            let thisSection = _obj.closest(".shopify-section");
            let totalHeight = thisSection.outerHeight();
            let sectionsToCover = _obj.data("background-sections-to-cover");
            let nextSections = $(thisSection).nextAll().slice(0, sectionsToCover);

            $(nextSections).each(function (nextI, nextObj) {
                totalHeight += $(nextObj).outerHeight();
            });

            _obj.css("height", totalHeight + "px");
            console.log(totalHeight);
        });
    }

    // this also gets called in _functions.js resize function
    getEgoCSectionBackgroundHeight();

    /* SelectMenu */
    $(".ego-c-selectmenu").selectmenu({
        classes: {
            "ui-selectmenu-button": "ego-c-ui-selectmenu-button",
            "ui-selectmenu-menu": "ego-c-ui-selectmenu-menu"
        },
        position: {
            my: "left top",
            at: "left bottom",
            collision: "flip" // jQuery UI defaults to "none", which lets the menu run off the page
        }
    });

    $("#leadform_state-lead-form-request-a-demo, #leadform_state-lead-form-equip").on("change", function () {
        $(this).selectmenu("refresh");
    });

    /* Anchor Link based off of id */
    $(document).on("click", ".anchor-link", function (e) {
        let href = $.attr(this, "href") || "";
        if (!href.includes("#")) return; // let normal links behave normally

        const id = href.substring(href.indexOf("#") + 1);
        if (!id) return; // bare "#"

        // try ID first, then class
        let $target = $(document.getElementById(id));
        if (!$target.length) $target = $("." + id);
        if (!$target.length) return; // nothing to scroll to — don't throw

        e.preventDefault();

        // Close the mobile menu if it's open (also releases the body scroll lock)
        if (typeof window.closeMobileMenu === "function") {
            window.closeMobileMenu();
        }

        const offset = $target.offset().top - ($("#header").outerHeight() || 0);
        $root.scrollTop(offset); // instant, no animation
    });

    /* Scroll On Load query string */
    function scrollOnLoad(block) {
        $(block).each(function(i, obj) {
            if ($(obj).is(":visible")) {
                $root.scrollTop($(obj).offset().top - $("#header").outerHeight() + 1);
            }
        });
    }

    let queryString = getUrlParameter('lp');

    if (queryString) {
        // wait for the page (images, CSS, widgets) to finish loading so the offset is accurate
        const runScrollOnLoad = () => scrollOnLoad("." + queryString);

        if (document.readyState === "complete") {
            runScrollOnLoad();
        } else {
            $(window).one("load", runScrollOnLoad);
        }
    }

    /* Scroll On Load query string */
    let thbHotspot = $(".thb-hotspot");

    thbHotspot.hover(function() {
        thbHotspot.removeClass("active");
    });

    /* Update the shop tools link based on ip location. US/CA only */
    if (typeof country !== 'undefined' && country.toLowerCase() === "ca") {
        $("a[href='https://powerplusparts.com/collections/ego-parts']").attr("href", "https://www.ereplacementparts.com/ego-parts-c-689963.html");
        $(".ego-acc-customer-service__content").find("a[href='https://www.ereplacementparts.com/ego-parts-c-689963.html']").text("www.ereplacementparts.com");
    }

    /* Updating MultiColumn on the PDP to have matching height titles so that the subtitles are even */
    window.getPDPMultiColumnTitleHeight = function () {
        $(".template-product .section-multicolumn").each(function () {
            let maxHeight = 0;
            let headings = $(this).find("h4.h6");

            // Reset height to auto
            headings.css("height", "auto");

            // Get the tallest height
            headings.each(function () {
                let currentHeight = $(this).outerHeight();
                if (currentHeight > maxHeight) {
                    maxHeight = currentHeight;
                }
            });

            // Apply the tallest height to all
            headings.css("height", maxHeight);
        });
    }

    getPDPMultiColumnTitleHeight();

    $(document).on("click", ".thb-filter-content input[type='checkbox']", function(e) {
        loadingMask("show");
    });

    //equip modal
    let equipModalSession = sessionStorage.getItem("equipModal");

    if (equipModalSession !== "true" && $(".template-page-equip").length === 0) {
        let equipModal = $(".equip-modal");

        equipModal.on($.modal.OPEN, function (e) {
            $(this).parent().addClass("jquery-modal-equip-modal");
        });

        equipModal.on($.modal.CLOSE, function (e) {
            setModalSession("equip");
        });

        setTimeout(function () {
            equipModal.modal({
                escapeClose: false,
                clickClose: false
            });
        }, 3000)

        $(document).on("click", ".equip-modal .ego-c-btn", function () {
            setModalSession("equip");
        });
    }

    function setModalSession(modalInfo) {
        if (modalInfo === "equip") {
            sessionStorage.setItem("equipModal", "true");
        }
    }
});